// Simplified version - minimal animations for performance
export default function AnimatedSection({
  children,
  variant = 'fadeUp',
  delay = 0,
  duration = 0.4,
  threshold = 0.1,
  style,
  ...props
}) {
  // Return plain div - no animations for maximum performance
  return (
    <div style={style} {...props}>
      {children}
    </div>
  );
}
